import get from '@invitato/helpers/dist/getLocale';

export default {
  invitation: get(`Buka Undangan`, 'Open Invitation'),
  announcement: get(`Buka Pemberitahuan`, `Open Announcement`),
};
